import { useState } from "react";

import Tabs from "../../components/Tabs";
import AvatarHome from "../../components/AvatarHome";
import ReportCSCM from "../../components/report/ReportCSCM";
import CardsAnalytics from "../../components/CardsAnalytics";
import ErrorReportForm from "../../components/ErrorReportForm";
import NextClassCSCM from "../../components/TableClass/NextClassCSCM";
import CustomerService from "../../pages/CustomerService/CustomerServiceHomeCSCM";
import ClassesWithoutTeacher from "../../components/TableClass/ClassesWithoutTeacher";

const HomeCompanyManager = () => {
  const [activeTab, setActiveTab] = useState("ANALYTICS");

  const options = [
    "ANALYTICS",
    "CHECK_IN",
    "BTN_CLASS_WITHOUT_TECHER",
    "CUSTOMER_SERVICE",
    "REPORT_FORM",
    "REPORT_UPDATE",
  ];

  return (
    <div className="containerHomeCompanyManager">
      <AvatarHome buttonUpdate />

      <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
        {options[0] === activeTab && <CardsAnalytics />}
        {options[1] === activeTab && <NextClassCSCM />}
        {options[2] === activeTab && <ClassesWithoutTeacher />}
        {options[3] === activeTab && <CustomerService />}
        {options[4] === activeTab && <ReportCSCM />}
        {options[5] === activeTab && <ErrorReportForm />}
      </Tabs>
    </div>
  );
};

export default HomeCompanyManager;
